import { render } from "./branch_wallet.vue?vue&type=template&id=5b0697db&scoped=true"
import script from "./branch_wallet.vue?vue&type=script&lang=js"
export * from "./branch_wallet.vue?vue&type=script&lang=js"

import "./branch_wallet.vue?vue&type=style&index=0&id=5b0697db&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/goldenaces-club/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0697db"]])

export default __exports__